import { render, staticRenderFns } from "./MainSection.vue?vue&type=template&id=3d6bd2f6"
import script from "./MainSection.vue?vue&type=script&lang=js"
export * from "./MainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports